var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    {
      class: _vm.fieldClass,
      attrs: {
        inline: _vm.inline,
        clearable: _vm.clearable,
        togglePassword: _vm.togglePassword
      }
    },
    [
      _vm.label
        ? _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _vm.clear && _vm.value
        ? _c(
            "span",
            {
              staticClass: "md-select-clear-selection",
              on: { click: _vm.clearSelection }
            },
            [
              _c("md-icon", { staticClass: "clear-icon-size" }, [
                _vm._v("clear")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("md-input", {
        ref: _vm.name,
        class: "text-align-" + _vm.align,
        attrs: {
          id: _vm.id,
          type: _vm.type,
          name: _vm.name,
          value: _vm.value,
          counter: _vm.counter,
          required: _vm.required,
          disabled: _vm.disabled,
          maxlength: _vm.maxlength,
          placeholder: _vm.placeholder,
          readonly: _vm.readonly,
          step: _vm.step,
          "aria-autocomplete": _vm.autocomplete ? "on" : "off",
          autocomplete: _vm.autocomplete ? "on" : "off"
        },
        on: {
          input: _vm.onInput,
          blur: _vm.onBlur,
          focus: _vm.onFocus,
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.onEnterKeypress.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("span", { staticClass: "md-error" }, [
            _vm._v(_vm._s(_vm.errorMessage))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bb8eea4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bb8eea4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/fields/InputField.vue
// module id = PMtN
// module chunks = 1